import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./tag.css.ts.vanilla.css-mistica.js";
var _ = "_1wy08671 _1y2v1nf65 _1y2v1nf7e _1y2v1nfb6 _1y2v1nfba _1y2v1nfbk _1y2v1nfbe _1y2v1nfd1 _1y2v1nfa2";
export { _ as tag };
